import React from "react"

import CheckoutFlowDatesStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-dates-step"
import CheckoutFlowPackageStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-package-step"
import CheckoutFlowGuestsAndAddOnsStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-guests-and-add-ons-step"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { CHECKOUT_STEPS } from "~config/constants"
import CheckoutFlowAccommodationsStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-accommodations-step"
import CheckoutFlowSummaryStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-summary-step"
import CheckoutFlowPaymentStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-payment-step"
import CheckoutFlowConfirmationStep from "~components/pages/listing/checkout/checkout-flow/checkout-flow-confirmation-step"
import WidgetListingDetails from "~widget/components/widget-listing-details/widget-listing-details"
import WidgetCheckoutFlowInfoStep from "~widget/components/widget-checkout-flow/widget-checkout-flow-info-step"
import useAutoPersistWidgetCheckoutSession from "~utils/use-auto-persist-widget-checkout-session"

export default function CheckoutFlowCurrentStep() {
    const { currentStep } = useCheckoutFlow()

    useAutoPersistWidgetCheckoutSession()

    return renderCurrentStep(currentStep)
}

function renderCurrentStep(currentStep: string | null) {
    switch (currentStep) {
        case CHECKOUT_STEPS.WIDGET_PACKAGE:
            return <WidgetListingDetails />
        case CHECKOUT_STEPS.DATES:
            return <CheckoutFlowDatesStep />
        case CHECKOUT_STEPS.PACKAGE:
            return <CheckoutFlowPackageStep />
        case CHECKOUT_STEPS.ACCOMMODATIONS:
            return <CheckoutFlowAccommodationsStep />
        case CHECKOUT_STEPS.GUESTS_AND_ADD_ONS:
            return <CheckoutFlowGuestsAndAddOnsStep />
        case CHECKOUT_STEPS.SUMMARY:
            return <CheckoutFlowSummaryStep />
        case CHECKOUT_STEPS.WIDGET_INFO:
            return <WidgetCheckoutFlowInfoStep />
        case CHECKOUT_STEPS.PAYMENT:
            return <CheckoutFlowPaymentStep />
        case CHECKOUT_STEPS.CONFIRMATION:
            return <CheckoutFlowConfirmationStep />
        default:
            return null
    }
}
